import React, { useEffect } from "react";
// import List from "src/pages/product/register/list";
// import Header from "src/pages/product/register/header";

import { useUserContext } from "src/contexts/userContext";
import _ from "lodash";
import { useProductContext } from "src/contexts/product/productContext";

const ERP_URL = "https://odoo.erdenetmc.mn";

const Index = () => {
  const { user } = useUserContext();

  const {  dispatch } = useProductContext();

  useEffect(() => {
    if (user.loggedIn) {
      var result = [];
      var roles = _.split(user.roles, " ");
      _.map(roles, (item) => {
        var role = _.split(item, "_");
        result.push(_.toInteger(role[1]));
      });

      dispatch({ type: "STATE", data: { product_ids: result } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.loggedIn]);

  // const { state, dispatch } = useProductContext();
  // return (
  //   <div className=" card flex  p-2 border rounded text-xs">
  //     <Header />

  //     <List />
  //   </div>
  // );
  return (
    <div className="card flex items-center justify-center p-4 border rounded min-h-[60vh] bg-bg-page">
      {/* <Header /> */}
      {/* <List /> */}
      <div className="w-full max-w-md bg-surface border border-border-subtle rounded-xl shadow-sm p-8 text-center">
        <div className="mx-auto mb-4 flex items-center justify-center w-16 h-16 rounded-full bg-primary-fixed/40">
          <i className="pi pi-calendar text-primary text-2xl" />
        </div>

        <h1 className="text-card-title text-text-primary mb-2">
          Бүртгэл ERP системээр явна.
        </h1>
        <p className="text-xs text-text-secondary mb-6">
          99228182 утасаар холбогдоно уу.
        </p>

        <a
          href={ERP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary text-on-primary text-sm font-semibold no-underline transition-colors hover:bg-primary-dark hover:text-on-primary"
        >
          ERP Систем рүү орох
          <i className="pi pi-external-link text-xs" />
        </a>

        <div className="mt-4 text-metadata text-text-tertiary">
          {ERP_URL.replace("https://", "")}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Index);
